import React, { useContext } from "react";
import { AuthContext } from "../AuthProvider";
import Mode from "../components/heating/Mode";
import TempSettings from "../components/heating/TempSettings";
import CombinedSchedule from "../components/controlpanel/CombinedSchedule";
import PeakLengthSetting from "../components/heating/PeakLengthSetting";
import ControlPanelMenu from "../components/controlpanel/ControlPanelMenu";


const Heating = () => {

    const { esp, espLoading } = useContext(AuthContext);

    return (
        <div className="detail-container">
            <ControlPanelMenu />
            <div className="card p-1">
                <div>
                    <h1 className="m-3">Uppvärmning inomhus</h1>
                </div>
                <div>
                    {!espLoading && !esp && <p>Du har ingen styrenhet kopplad till ditt kundkonto.</p>}
                    {esp && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <Mode />
                                    <TempSettings />
                                    <PeakLengthSetting />
                                </div>
                            </div>
                            <CombinedSchedule showOnlyHeating={true} />
                        </>
                    )}
                </div>
            </div>
        </div >

    )
}

export default Heating;


